import React from 'react';
import {
    Responsive,
    Filter,
    RadioButtonGroupInput,
    SimpleList,
    Datagrid,
    TextField,
    DateField,
} from 'admin-on-rest';
import List from '../admin/List';
import LinkedTextField from '../components/LinkedTextField';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/lock';

export const fuseLoyaltyAccountLockIcon = Icon;

const styles = {
    filterInput: {display: 'inline-block'},
    fieldSmall: {flex: '0 1 10%', display: 'inline-block', maxWidth: '8.5em', overflow: 'hidden'},
};

/*
 * View: List
 */

const LoyaltyAccountFilter = (props) => (
    <Filter {...props}>
        <RadioButtonGroupInput
            source="loyalty_lock"
            label="View by Account Lock Type"
            choices={[
                {id: 'fraud_locked', value: 'fraud_locked', name: 'Fraud Locked'},
                {id: 'temp_locked', value: 'temp_locked', name: 'Temp Locked'},
            ]}
            options={{defaultSelected: 'fraud_locked'}}
            alwaysOn
            style={viewStyles.filterLeft} elStyle={styles.filterInput}/>
    </Filter>
);

// Set title for List Fraud/Temp Logs
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                className="avatar-title"/>Account Lock Logs</span>;

const ListDescription = () => {
    return (
        <span>
            <p>A <strong>Fraud Lock</strong> or <strong>Temp Lock</strong> is set on Customers using fraudulent data
                during transactions, or who undergo a series of failed transaction attempts. These Accounts are marked
                with Fraud Lock or Temp Lock until they are reviewed.</p>
        </span>
    );
};

export const fuseLoyaltyAccountLogList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} filters={<LoyaltyAccountFilter/>}
          sort={{field: 'customer', order: 'ASC'}} perPage={100}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => 'Location ' + record.client.location}
                    secondaryText={record => 'Register ' + record.transaction_type}
                    tertiaryText={record => record.customer}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <LinkedTextField
                        source="customer" label="Customer"
                        linkPath="LoyaltyAccounts" linkType="show"
                    />
                    <TextField source="client.location" label="Location" sortable={false}/>
                    <TextField source="transaction_type" label="Transaction"/>
                    <DateField source="modified" label="Date" showTime sortable={false}/>
                </Datagrid>
            }
            large={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <LinkedTextField
                        source="customer" label="Customer"
                        linkPath="LoyaltyAccounts" linkType="show"
                    />
                    <TextField source="client.location" label="Location" sortable={false}/>
                    <TextField source="client.user" label="User" sortable={false}/>
                    <TextField source="client.register" label="Register" sortable={false}/>
                    <TextField source="transaction_type" label="Transaction"/>
                    <DateField source="modified" label="Date" showTime sortable={false}/>
                </Datagrid>
            }
        />
    </List>
);



// WEBPACK FOOTER //
// ./src/Fuse/Loyalty/log.js